import { useEffect } from 'react'

const usePageTitle = (pageTitle) => {
    useEffect(() => {
        document.title = pageTitle || 'VideoBoost by Gather Voices';
    }, [pageTitle]);
}

export default usePageTitle
